import React, {Component} from "react";
import {AutoComplete} from "primereact/autocomplete";
import RemotingService from "../../../../services/remoting-service/RemotingService";

const normalize = (name) => name.trim().toLowerCase();

/**
 * Free text input that suggests names previously entered by any user. Selecting a suggestion or pressing Enter
 * passes the name to onAdd; names already in `selected` are neither suggested nor added again.
 */
export default class TagSuggestionInput extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: "",
            suggestions: []
        };
    }

    isSelected = (name) => {
        return this.props.selected.some(selectedName => normalize(selectedName) === normalize(name));
    }

    search = (event) => {
        RemotingService.getRemoteCall(this.props.suggestionUrl, {query: event.query}, (names) => {
            // The value is empty when the name was added before the response came back; drop the stale result
            const suggestions = this.state.value ? names.filter(name => !this.isSelected(name)) : [];
            this.setState({suggestions});
        }, null, false);
    }

    add = (name) => {
        if (name && name.trim() && !this.isSelected(name)) {
            this.props.onAdd(name.trim());
        }
        this.setState({value: "", suggestions: []});
    }

    handleKeyUp = (event) => {
        // AutoComplete prevents the default of Enter while its panel is open, so keypress never fires; keyup does.
        // When Enter picked a highlighted suggestion, onSelect already added it and cleared the value.
        if (event.key === "Enter") {
            this.add(this.state.value);
            this.autoComplete && this.autoComplete.hidePanel();
        }
    }

    render() {
        return (
            <AutoComplete ref={el => this.autoComplete = el}
                          className={this.props.className}
                          inputClassName="w-100"
                          appendTo={document.body}
                          value={this.state.value}
                          suggestions={this.state.suggestions}
                          completeMethod={this.search}
                          delay={250}
                          maxlength={255}
                          onChange={event => this.setState({value: event.value})}
                          onSelect={event => this.add(event.value)}
                          onKeyUp={this.handleKeyUp}/>
        );
    }
}
